import React from "react";
import { useMutation } from "react-query";

import { SyncOutlined } from "@ant-design/icons";
import { message } from "antd";

// Components
import { convertToBaseProduct } from "api/fulfillment/product";

import { Product } from "../../../../../interfaces/products";
import { Button } from "../ProductInfo.styles";
// Apis

interface ConvertToBPButtonProps {
  product: Product;
  onRefetchProduct: () => unknown;
}

const ConvertToBPButton: React.FC<ConvertToBPButtonProps> = ({ product, onRefetchProduct }) => {
  const { mutate: convertToBaseProductMutation, isLoading: isConvertingProduct } = useMutation(convertToBaseProduct, {
    onSuccess: ({ recipient_email }) => {
      message.success(
        `We're processing your conversion request. We will send an email to ${recipient_email} when it's completed.`
      );
    },
    onSettled: () => {
      onRefetchProduct();
    },
  });

  const submitConvertBaseProduct = () => {
    convertToBaseProductMutation({
      productID: product.id,
    });
  };

  return (
    <Button
      margin="0 16px 0 0"
      onClick={submitConvertBaseProduct}
      icon={<SyncOutlined />}
      disabled={isConvertingProduct}
    >
      Convert to Base Product
    </Button>
  );
};

export { ConvertToBPButton };
